import React, { useState } from 'react'
import { Helmet } from "react-helmet";
import useDocumentTitle from "../../useDocumentTitle";
import Modal_started from '../Home/Modal_started';
import { Link } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";

const Article_como_controlar_el_inventario_de_un_restaurante_y_reducir_las_mermas_en_peru = () => {

    useDocumentTitle(
        "Cómo controlar el inventario de un restaurante y reducir las mermas en Perú | Invu POS"  
    ); 

  const [isOpenOptions, setIsOpenOptions] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const prefix = useLocalePrefix();
    
  return (
    <>
    <Helmet>
        <meta
            name="description"
            content="En un restaurante, vender más no siempre significa ganar más. Un negocio puede tener una gran cantidad de pedidos todos los días y aun así perder dinero por ingredientes desperdiciados, compras excesivas, productos vencidos, errores en las porciones o diferencias entre el inventario registrado y el inventario real. Por eso, tener un buen control de inventario para restaurantes es fundamental para conocer cuánto compras, cuánto utilizas, cuánto desperdicias y cuánto realmente te cuesta preparar cada plato."
        />
        <meta name="keywords" content="Cómo controlar el inventario de un restaurante y reducir las mermas en Perú" />
    </Helmet>
    {isOpen && <Modal_started setIsOpen={setIsOpen} />}
    <section class="w-full px-4 py-24 mx-auto max-w-7xl md:w-4/5">
    <div class="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
      <div class="col-span-1 md:col-span-2 lg:col-span-2 xl:col-span-3">
        <h1 class="mb-10 text-5xl font-medium text-gray-900 md:text-6xl max-w-6xl" itemprop="headline">
        Cómo controlar el inventario de un restaurante y reducir las mermas en Perú
        </h1>
      </div>
    </div>
    <div className="max-w-screen-xl mx-auto mt-4">
        <div class="grid flex-col-reverse items-center grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-y-10 md:gap-y-16 gap-x-10 md:gap-x-16">
          <div class="order-none lg:order-2 md:order-none">
          <p className="text-xl text-gray-900 font-light leading-relaxed mb-12">
          En un restaurante, vender más no siempre significa ganar más. Un negocio puede tener una gran cantidad de pedidos todos los días y aun así perder dinero por ingredientes desperdiciados, compras excesivas, productos vencidos, errores en las porciones o diferencias entre el inventario registrado y el inventario real. Por eso, tener un buen control de inventario para restaurantes es fundamental para conocer cuánto compras, cuánto utilizas, cuánto desperdicias y cuánto realmente te cuesta preparar cada plato.
          </p>
        <div className="flex items-center space-x-2 mt-4 text-gray-500 uppercase text-xs font-semibold">
          <span>By <span className="text-black">Andrés Amaya</span></span>
          <span>&#8212;</span>
          <span>August 10, 2026</span>
          <span>&#8212;</span>
          <span className="text-black">8 MIN READ</span>
        </div>
        <div className="flex space-x-2 mt-4">
          <span className="bg-blue-100 text-black text-xs font-semibold px-3 py-1 rounded">ARTÍCULO</span>
          <span className="bg-gray-200 text-black text-xs font-semibold px-3 py-1 rounded">GESTIÓN</span>
        </div>
        {/* Social Icons */}
        <div className="flex space-x-4 mt-6">
        <div class="flex items-center">
                <div class="flex space-x-6 text-gray-500">
                <a
                  class="hover:opacity-75"
                  href="https://www.instagram.com/invupos/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span class="sr-only"> Instagram </span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </a>

                <a
                  class="hover:opacity-75"
                  href="https://twitter.com/invupos?lang=es"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span class="sr-only"> Twitter </span>
                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>

                <a
                  class="hover:opacity-75"
                  href="https://es-la.facebook.com/invuposofficial/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span class="sr-only"> Facebook </span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </a>
              </div>
              </div>
        </div>
            </div>
            <div className="relative lg:m-auto group flex justify-center h-full w-full">
              <img
                className="object-center object-cover h-96 w-full rounded-2xl"
                src="https://img.invupos.com/webinvu/Blog%20invu/951fcb33-d360-4695-9066-f844a9c2aff6.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <hr class="my-16 h-0.5 border-t-0 bg-neutral-100" />

        <div className="bg-white flex flex-col md:flex-row justify-center items-start">
      {/* Sidebar - Table of Contents */}
      <div className="w-full md:w-1/3 md:pr-10 mb-10 md:mb-0">
        <div className="md:hidden">
          <button
            className="w-full flex items-center justify-between text-md font-semibold p-3 py-4 border-t border-b"
            onClick={() => setIsOpenOptions(!isOpenOptions)}
          >
             <span className="flex">Table of contents</span>
             <span className="ml-auto transition-transform duration-300 transform" style={{ transform: isOpenOptions ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              {isOpenOptions ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M11.293 7.293a1 1 0 0 1 1.32 -.083l.094 .083l6 6l.083 .094l.054 .077l.054 .096l.017 .036l.027 .067l.032 .108l.01 .053l.01 .06l.004 .057l.002 .059l-.002 .059l-.005 .058l-.009 .06l-.01 .052l-.032 .108l-.027 .067l-.07 .132l-.065 .09l-.073 .081l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002h-12c-.852 0 -1.297 -.986 -.783 -1.623l.076 -.084l6 -6z" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z" />
                </svg>
              )}
            </span>
          </button>
          {isOpenOptions && (
            <ul className="text-gray-700 space-y-2 text-md bg-gray-100 p-4 mt-6 rounded">
              <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/punto-de-venta" className="hover:text-indigo-500 transition-colors duration-300">
                    Punto de venta
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/comercio-electronico" className="hover:text-indigo-500 transition-colors duration-300">
                    E-commerce
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/programa-de-lealtad" className="hover:text-indigo-500 transition-colors duration-300">
                    Lealtad
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/kds" className="hover:text-indigo-500 transition-colors duration-300">
                    KDS
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/quioscos" className="hover:text-indigo-500 transition-colors duration-300">
                    Autoservicio
                </Link>
                </li>
            </ul>
          )}
        </div>
        <div className="hidden md:block">
        <h2 className="text-xl font-semibold mb-4">Nuestros Productos</h2>
            <ul className="text-gray-700 space-y-2 text-lg">
            <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/punto-de-venta" className="hover:text-indigo-500 transition-colors duration-300">
                    Punto de venta
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/comercio-electronico" className="hover:text-indigo-500 transition-colors duration-300">
                    E-commerce
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/programa-de-lealtad" className="hover:text-indigo-500 transition-colors duration-300">
                    Lealtad
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/kds" className="hover:text-indigo-500 transition-colors duration-300">
                    KDS
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/quioscos" className="hover:text-indigo-500 transition-colors duration-300">
                    Autoservicio
                </Link>
                </li>
          </ul>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="w-full md:w-2/3 text-left">
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        En <span className="font-semibold">Perú</span>, donde los restaurantes trabajan diariamente con productos frescos y perecederos, optimizar el inventario puede marcar una diferencia importante en la rentabilidad del negocio.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        ¿Qué son las mermas en un restaurante?
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Las <span className="font-semibold">mermas</span> son las pérdidas de productos o ingredientes que ocurren durante la operación de un restaurante.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Pueden producirse por diferentes razones:
        </p>

        <ul className="list-disc ml-6 space-y-2 mb-10 text-xl text-gray-900 font-light">
        <li>Productos que vencen antes de ser utilizados.</li>
        <li>Alimentos que se dañan por un almacenamiento incorrecto.</li>
        <li>Exceso de preparación.</li>
        <li>Porciones más grandes de lo establecido.</li>
        <li>Derrames o accidentes.</li>
        <li>Errores durante la preparación.</li>
        <li>Compras superiores a la demanda real.</li>
        <li>Productos que desaparecen o no quedan registrados correctamente.</li>
        <li>Diferencias entre el inventario físico y el inventario registrado.</li>
        </ul>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        El problema es que muchas de estas pérdidas pueden pasar desapercibidas. Un restaurante puede estar perdiendo pequeñas cantidades todos los días que, acumuladas durante un mes, representan una cantidad importante de dinero.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        1. Conoce exactamente qué tienes en inventario
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        El primer paso para mejorar la <span className="font-semibold">gestión de inventario de un restaurante</span> es saber qué productos tienes, cuánto tienes disponible y dónde están almacenados.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        No basta con revisar visualmente el almacén.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Es importante registrar productos como:
        </p>

        <ul className="list-disc ml-6 space-y-2 mb-10 text-xl text-gray-900 font-light">
        <li>Carnes.</li>
        <li>Pescados y mariscos.</li>
        <li>Frutas y verduras.</li>
        <li>Lácteos.</li>
        <li>Bebidas.</li>
        <li>Productos secos.</li>
        <li>Salsas y condimentos.</li>
        <li>Productos de limpieza.</li>
        <li>Insumos utilizados en la preparación.</li>
        </ul>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Cada producto debería tener información sobre cantidad, unidad de medida, costo y movimiento.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        De esta manera puedes saber qué productos tienen mayor rotación y cuáles permanecen demasiado tiempo almacenados.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        2. Utiliza recetas para controlar el consumo de ingredientes
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Uno de los mayores problemas en los restaurantes es que un mismo plato puede utilizar diferentes cantidades de ingredientes dependiendo de quién lo prepare.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Por ejemplo, si una hamburguesa debería utilizar 150 gramos de carne, pero algunos empleados utilizan 170 o 180 gramos, esa diferencia termina convirtiéndose en una pérdida.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Por eso es importante crear <span className="font-semibold">recetas estandarizadas</span>.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Una receta puede establecer:
        </p>

        <ul className="list-disc ml-6 space-y-2 mb-10 text-xl text-gray-900 font-light">
        <li>Ingredientes utilizados.</li>
        <li>Cantidad por porción.</li>
        <li>Costo de cada ingrediente.</li>
        <li>Costo total del plato.</li>
        <li>Precio de venta.</li>
        <li>Margen estimado.</li>
        </ul>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Cuando una receta está conectada al sistema de ventas, cada vez que se vende un plato se puede descontar del inventario la cantidad correspondiente de ingredientes.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        Esto permite tener una visión mucho más precisa del consumo real.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        3. Controla el inventario en tiempo real
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Utilizar hojas de cálculo o registros manuales puede funcionar cuando un negocio es muy pequeño, pero a medida que aumentan las ventas, las sucursales y los productos, mantener la información actualizada se vuelve más complicado.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Un <span className="font-semibold">sistema POS para restaurantes</span> puede conectar las ventas con el inventario.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Por ejemplo:
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        Se vende un ceviche → se registra la venta → se descuentan los ingredientes de la receta → se actualiza el inventario.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed">
        Esto permite que el administrador tenga una visión más cercana al stock disponible sin depender exclusivamente de conteos manuales.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        4. Realiza inventarios físicos periódicamente
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Aunque utilices un <span className="font-semibold">software para restaurantes</span>, los inventarios físicos siguen siendo importantes.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Puedes establecer diferentes frecuencias según el tipo de producto:
        </p>

        <h3 className="text-2xl font-semibold mb-3 mt-6">
        Diariamente
        </h3>

        <ul className="list-disc ml-6 space-y-2 mb-6 text-xl text-gray-900 font-light">
        <li>Productos de alta rotación.</li>
        <li>Carnes.</li>
        <li>Pescados.</li>
        <li>Mariscos.</li>
        <li>Productos perecederos.</li>
        </ul>

        <h3 className="text-2xl font-semibold mb-3 mt-6">
        Semanalmente
        </h3>

        <ul className="list-disc ml-6 space-y-2 mb-6 text-xl text-gray-900 font-light">
        <li>Frutas y verduras.</li>
        <li>Lácteos.</li>
        <li>Bebidas.</li>
        <li>Productos de mayor consumo.</li>
        </ul>

        <h3 className="text-2xl font-semibold mb-3 mt-6">
        Mensualmente
        </h3>

        <ul className="list-disc ml-6 space-y-2 mb-10 text-xl text-gray-900 font-light">
        <li>Productos secos.</li>
        <li>Insumos de menor rotación.</li>
        <li>Inventario general.</li>
        </ul>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        La comparación entre el <span className="font-semibold">stock teórico</span> y el <span className="font-semibold">stock físico</span> puede ayudarte a detectar diferencias y encontrar dónde se están produciendo las pérdidas.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        5. Aplica el método FIFO
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Para productos perecederos, una buena práctica es utilizar el principio <span className="font-semibold">FIFO (First In, First Out)</span>: los productos que ingresaron primero deben ser utilizados primero.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Esto ayuda a reducir el riesgo de que alimentos permanezcan demasiado tiempo almacenados y terminen vencidos.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        Por ejemplo, si recibes dos cajas de tomates en diferentes días, la caja más antigua debería utilizarse antes que la nueva. Una correcta organización del almacén también facilita este proceso.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        6. Controla las compras según el consumo real
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Comprar demasiado puede parecer una buena estrategia para obtener mejores precios, pero en un restaurante puede convertirse rápidamente en desperdicio.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Antes de realizar una compra, analiza:
        </p>

        <ul className="list-disc ml-6 space-y-2 mb-10 text-xl text-gray-900 font-light">
        <li>Ventas históricas.</li>
        <li>Consumo promedio.</li>
        <li>Días de mayor demanda.</li>
        <li>Temporadas.</li>
        <li>Promociones.</li>
        <li>Inventario disponible.</li>
        <li>Productos próximos a vencer.</li>
        </ul>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Un sistema de <span className="font-semibold">control de inventario para restaurantes</span> permite utilizar los datos de ventas para tomar mejores decisiones de compra.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        La idea no es simplemente comprar menos, sino <span className="font-semibold">comprar lo que realmente necesitas</span>.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        7. Identifica los productos que generan más pérdidas
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        No todos los ingredientes representan el mismo impacto económico.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Puedes tener una gran cantidad de desperdicio de un producto barato y una pequeña merma de un producto costoso. Ambos casos deben analizarse de manera diferente.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Por eso es importante identificar:
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        <span className="font-semibold">Productos con mayor rotación + productos con mayor costo + productos con mayor nivel de desperdicio.</span>
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        Esta información permite determinar dónde debes concentrar tus esfuerzos.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        8. Mide el costo real de tus platos
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Controlar el inventario también ayuda a conocer el <span className="font-semibold">food cost</span> de cada plato.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Si sabes cuánto cuesta cada ingrediente y cuánto utilizas para preparar una receta, puedes determinar cuánto te cuesta realmente producirla.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Por ejemplo:
        </p>

        <ul className="list-disc ml-6 space-y-2 mb-10 text-xl text-gray-900 font-light">
        <li>Precio de venta: S/ 35</li>
        <li>Costo de ingredientes: S/ 10</li>
        <li>Otros costos: variables según el negocio</li>
        </ul>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Esto permite tomar mejores decisiones sobre precios, promociones y rentabilidad.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        No todos los platos que venden mucho son necesariamente los más rentables.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        9. Utiliza tecnología para reducir las mermas
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        La tecnología puede ayudar a centralizar las diferentes áreas de la operación.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Con un sistema como <span className="font-semibold">INVU POS</span>, un restaurante puede conectar ventas, inventario, recetas, productos y reportes dentro de una misma plataforma.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        Esto permite reducir la dependencia de registros manuales y obtener información que ayude a tomar decisiones basadas en datos.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        En lugar de preguntarte:
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        <span className="font-semibold">“¿Cuánto inventario nos queda?”</span>
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        puedes pasar a preguntarte:
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed">
        <span className="font-semibold">“¿Qué estamos consumiendo, cuánto nos cuesta y dónde estamos perdiendo dinero?”</span>
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mt-6">
        Ese cambio puede tener un impacto importante en la gestión del restaurante.
        </p>
      </div>
    </div>


   
    <div className="bg-white flex flex-col md:flex-row justify-center items-start mt-14">
      {/* Sidebar - Table of Contents */}
      <div className="w-full md:w-1/3 md:pr-10 mb-10 md:mb-0">
      <div className="bg-white flex flex-col items-start text-left p-6 max-w-md mx-auto">
      {/* Heading */}
      <h2 className="text-3xl font-medium leading-tight mb-4">
      Obtén más información sobre Invu POS
      </h2>
      
      {/* Image */}
      <div className="w-full rounded-lg overflow-hidden mb-6">
        <img
          src="https://images.pexels.com/photos/7682340/pexels-photo-7682340.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          alt="Business Tools"
          className="w-full h-auto object-cover"
        />
      </div>
      
      {/* Button */}
      <button
        className="px-6 py-3 border border-blue-500 text-blue-500 font-medium rounded-lg hover:bg-blue-100 transition duration-300"
        onClick={() => {
            setIsOpen(true);
        }}
      >
       Empieza Hoy ↗
      </button>
    </div>
      </div>
      
      {/* Main Content */}
      <div className="w-full md:w-2/3 text-left">
        <h2 className="text-4xl font-bold mb-4 mt-10">
        10. Convierte el inventario en una herramienta para ganar más
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        El inventario no debería verse solamente como una tarea administrativa. Bien gestionado, puede convertirse en una herramienta para mejorar la rentabilidad.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
        Un restaurante que conoce su inventario puede:
        </p>

        <ul className="list-disc ml-6 space-y-2 mb-10 text-xl text-gray-900 font-light">
        <li>Comprar mejor.</li>
        <li>Reducir desperdicios.</li>
        <li>Controlar las porciones.</li>
        <li>Detectar diferencias.</li>
        <li>Conocer el costo de sus platos.</li>
        <li>Identificar productos de alta y baja rotación.</li>
        <li>Evitar quiebres de stock.</li>
        <li>Mejorar sus márgenes.</li>
        <li>Tomar decisiones basadas en información real.</li>
        </ul>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        La clave está en conectar ventas e inventario
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Un buen <span className="font-semibold">control de inventario en restaurantes</span> comienza mucho antes de abrir el almacén. Empieza desde el momento en que se registra una compra y continúa hasta que un ingrediente termina convertido en un plato vendido al cliente.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        Cuando ventas, recetas e inventario trabajan de forma integrada, el restaurante puede tener una visión mucho más clara de lo que sucede con sus productos y sus costos.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-10">
        Para los restaurantes en <span className="font-semibold">Perú</span> que buscan mejorar su operación, implementar un <span className="font-semibold">sistema POS con control de inventario</span> puede ser un paso importante hacia una gestión más eficiente y rentable.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
        ¿Quieres tener mayor control sobre tu restaurante?
        </h2>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Con <span className="font-semibold">INVU POS</span>, puedes centralizar la gestión de tu restaurante y obtener información sobre ventas, inventario y operación desde una misma plataforma.
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        <span className="font-semibold">Menos desperdicio. Más control. Mejores decisiones.</span>
        </p>

        <p className="text-xl text-gray-900 font-light leading-relaxed">
        Descubre cómo <span className="font-semibold">INVU POS</span> puede ayudarte a llevar la gestión de tu restaurante al siguiente nivel.
        </p>
      </div>    
    </div>
  </section>

    </>
  )
}

export default Article_como_controlar_el_inventario_de_un_restaurante_y_reducir_las_mermas_en_peru;